import { HttpErrorCode, normalizeHttpError } from '../../errors/httpErrors';
import axiosInstance from '../../utils/axiosInterceptor';
import { Cabinet } from '../../types';

/**
 * @function fetchCabinet
 * @description Recupere les informations d'un cabinet par son UUID.
 * @param {string} uuid - L'identifiant du cabinet.
 * @returns {Promise<Cabinet>} - Le cabinet correspondant.
 */
export const fetchCabinet = async (uuid: string): Promise<Cabinet> => {
  try {
    const response = await axiosInstance.get(`api/cabinets/${uuid}`);
    const data = response.data;

    return {
      id: data.id,
      siren: data.siren,
      nic: data.nic,
      companyName: data.companyName,
    };
  } catch (error) {
    throw normalizeHttpError(
      error,
      {
        [HttpErrorCode.SERVER_ERROR]:
          'Un probleme est survenu lors du chargement du cabinet. Veuillez reessayer ou contacter le support.',
        [HttpErrorCode.NETWORK_ERROR]:
          'Impossible de charger le cabinet. Verifiez votre connexion.',
        [HttpErrorCode.NOT_FOUND]: 'Le cabinet demande est introuvable.',
      },
      'Echec de la recuperation du cabinet. Veuillez reessayer.',
    );
  }
};
